import { PropTypes } from 'react-desc';
import { FORMITEM_LAYOUT_VARIANTS } from './variants.js';

var props = {
  /** props to inject to form item layout wrapper */
  containerProps: PropTypes.object.description('props to inject to form item layout wrapper'),

  /** disableTooltip */
  disableTooltip: PropTypes.bool.description('Whether to show a tooltip or not when text does not fit').defaultValue(true),

  /** position label on the left */
  leftLabel: PropTypes.bool.description('position label on the left'),

  /** turn on floating label */
  floatingLabel: PropTypes.bool.description('turn on floating label'),

  /** id for form item layout */
  id: PropTypes.string.description('id for form item layout'),

  /** html name prop for form tags */
  name: PropTypes.string.description('html name prop for form tags'),

  /** form item layout element value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).description('form item layout element value'),

  /** Any input component */
  inputComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).description('Any input component'),

  /** isShowElipsisActive */

  /** isShowElipsisActive */
  isShowElipsisActive: PropTypes.bool.description('Wheter to enable the ellipsis and tooltip functionality or not').defaultValue(true),

  /** Label component  */
  labelComponent: PropTypes.element.description('Label component'),

  /** feedback component to embed on form item */
  feedbackComponent: PropTypes.node.description('feedback component to embed on form item'),

  /** label text */
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).description('label text'),

  /** error state */
  hasError: PropTypes.bool.description('error state'),

  /** validation state */
  validationState: PropTypes.oneOf(['success', 'error', 'warning']).description('validation state'),

  /** validation message */
  validationMessage: PropTypes.string.description('validation message'),

  /** feedback message */
  feedbackMessage: PropTypes.string.description('feedback message'),

  /** read only form item */
  readOnly: PropTypes.bool.description('read only form item'),

  /** focused state */
  focused: PropTypes.bool.description('focused state'),

  /** input type */
  type: PropTypes.string.description('input type'),

  /** auto focus input */
  autoFocus: PropTypes.bool.description('auto focus input'),

  /** disabled state */
  disabled: PropTypes.bool.description('disabled state'),

  /** on change handler */
  onChange: PropTypes.func.description('on change handler'),

  /** on blur handler */
  onBlur: PropTypes.func.description('on blur handler'),

  /** extra input props to inject */
  extraInputProps: PropTypes.object.description('extra input props to inject'),

  /** extra content */
  extraContent: PropTypes.element.description('extra content'),

  /** left addon for form item */
  leftAddon: PropTypes.element.description('left addon for form item'),

  /** right addon for form item */
  rightAddon: PropTypes.element.description('right addon for form item'),

  /** add required mark */
  required: PropTypes.bool.description('add required mark'),

  /** add optional mark */
  optional: PropTypes.bool.description('add optional mark'),

  /** on focus handler */
  onFocus: PropTypes.func.description('on focus handler'),

  /** on paste handler */
  onPaste: PropTypes.func.description('on paste handler'),

  /** add truncation and ellipsis */
  truncateText: PropTypes.bool.description('add truncation and ellipsis'),

  /** on key up event handler */
  onKeyUp: PropTypes.func.description('on key up event handler'),

  /** mask for input mask component */
  mask: PropTypes.oneOfType([// PropTypes.oneOf(maskTypes),
  PropTypes.string, PropTypes.func]).description('mask for input mask component'),

  /** add suffix to input */
  useSubfix: PropTypes.string.description('add suffix to input'),

  /** suffix for input */
  suffix: PropTypes.string.description('suffix for input'),

  /** form item layout type */
  variant: PropTypes.oneOf([FORMITEM_LAYOUT_VARIANTS.DEFAULT, FORMITEM_LAYOUT_VARIANTS.FOCUS, FORMITEM_LAYOUT_VARIANTS.ACTIVE, FORMITEM_LAYOUT_VARIANTS.DISABLED, FORMITEM_LAYOUT_VARIANTS.READ_ONLY, FORMITEM_LAYOUT_VARIANTS.OPTIONAL]).description('form item layout type')
};

export { props };
//# sourceMappingURL=props.js.map
